// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3_ZtZ","footer":"ReportModalFilter_footer__10z8H"};